﻿export function d2r(degrees) {
	return (degrees * Math.PI) / 180;
}

export function r2d(radians) {
	return (radians * 180) / Math.PI;
}
